import { ContentBox } from "@msuite/ui/app-shell";
import { parseAsStringLiteral, useQueryState } from "@msuite/ui/libs/nuqs";
import { DataTable } from "@msuite/ui/table";
import { useState } from "react";
import {
	INCOMING_INVOICE_STATE_FILTERS,
	IncomingInvoiceStatePicker,
} from "@/components/pickers/incoming-invoice-state-picker";
import { useIncomingInvoices } from "@/hooks/use-incoming-invoices";
import { ExportPaymentsButton } from "./export-payments-button";
import { columns } from "./table-config";

export function IncomingInvoices() {
	/** State */
	const [rowSelection, setRowSelection] = useState<Record<string, boolean>>({});
	// Remounting the table is what clears its selection once the picked invoices are paid.
	const [tableKey, setTableKey] = useState(0);
	const [stateFilter, setStateFilter] = useQueryState(
		"state",
		parseAsStringLiteral(INCOMING_INVOICE_STATE_FILTERS).withDefault("received"),
	);

	/** Query */
	const { incomingInvoices, isLoading, queryKey, refetch } = useIncomingInvoices();

	/** Functions */
	function handleOnExported() {
		setRowSelection({});
		setTableKey((key) => key + 1);
	}

	/** Computed */
	const filtered =
		stateFilter === "all"
			? incomingInvoices
			: incomingInvoices.filter((invoice) => invoice.state === stateFilter);
	// Only an approved invoice can be picked; one that left that state since stays out.
	const selected = filtered.filter(
		(invoice) => rowSelection[invoice.id] && invoice.state === "approved",
	);

	/** Render */
	return (
		<ContentBox>
			<DataTable
				key={tableKey}
				data={filtered}
				columns={columns}
				isLoading={isLoading}
				queryKey={queryKey}
				refetch={refetch}
				menu={() => (
					<div className="h-stack">
						<IncomingInvoiceStatePicker
							value={stateFilter}
							onChange={setStateFilter}
						/>
						<ExportPaymentsButton
							incomingInvoices={selected}
							onComplete={handleOnExported}
						/>
					</div>
				)}
				persistenceKey="incoming-invoices-table"
				initialPinningState={{ start: ["number"], end: ["state"] }}
				enableRowSelection={(row) => row.original.state === "approved"}
				enableMultiRowSelection
				onRowSelectionChange={setRowSelection}
			/>
		</ContentBox>
	);
}
